export const meta = {
  title: '账单与订阅',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'staff'],
};

关于您支付的一切都在后台的**账单**页面:您的套餐、试用状态、下次扣费日期、当前计费的门店数量,以及历来开出的每一张账单。没有莫名其妙的收费——每次变动都写入一份您随时可查的审计日志。

## 试用期

账号从**14 天免费试用**开始,功能全开——不绑卡,不扣款。账单页面会准确显示试用还剩几天。试用期内取消,分文不欠。

## 月度账单如何生成

计费采用**后付制**:每月 1 日凌晨,系统开出一张账单,覆盖刚刚结束的那个月。账单逐项列出您的套餐、额外门店,以及月中变更产生的按天折算费用——总额绝不会让您意外。

## 支付账单

账单页面上每张未付账单都有**立即支付**按钮,点击进入安全的 FPX 支付页——用任意马来西亚银行账户直接付款。银行确认后,账单自动变为*已付*,通常只需片刻。

如果支付链接已失效,用账单旁的刷新操作生成新链接。请注意:每张账单只有**最新**的链接才能完成支付——旧链接会被拒绝,以避免重复扣款。

## 添加门店

在**门店**页面添加门店。确认前,您会看到按天折算费用的实时预览——只需支付当月剩余天数的费用,该金额计入您的下一张账单。新门店即刻可用,拥有自己的队伍和二维码。

## 移除门店

移除门店在**月底**生效。在那之前它照常运作——那些天数您已经付过了——然后从下一张账单中消失。账单页面会列出待移除的门店及其生效日期,一目了然。

## SST 与税务发票

如果您的企业已注册 SST,请在账单页面打开税务卡片(仅店主可见),启用后填写 SST 编号和法人实体信息。此后每张账单都会包含 SST 项,其 PDF 将以正式税务发票的格式生成。

## 账单 PDF

每张账单都有 **PDF** 按钮——下载后交给会计或自行存档。已付账单会显示付款时间和方式。

## 审计记录

账单页面底部是您的**订阅事件**流水:每次套餐变更、门店添加、移除和扣费,全部带时间戳。若账单上有哪个数字看着眼生,这份流水会告诉您它从何而来。
